import React__default from 'react';
import { M as MenuItemButton } from '../../../Menu/MenuItem/MenuItemButton-r77zK5DX.js';

const SplitButtonItem = props => /*#__PURE__*/React__default.createElement(MenuItemButton, props);

export { SplitButtonItem as S };
//# sourceMappingURL=SplitButtonItem-nZ3judoB.js.map
